import Navbar from "../Navbar/Navbar";
import SideMenu from "./SideMenu";
import React, {useEffect, useRef, useState} from "react";
import ApiHttpClient from "@/HttpClient";
import {InvoiceDetailsModel, WorkingPointModel} from "@/api/Models";
import {WorkingPointResponse} from "@/components/MyAccount/UserManagement/AddNewUserPage";
import {InvoiceListResponse, InvoiceListResponseItem} from "@/api/InvoicesAPI";
import {toast} from "@/components/ui/use-toast";
import DatePicker from "react-datepicker";

const SearchInput: React.FC<any> = ({searchInvoice, setSearchInvoice, setIsNewSearch}) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.value.length > 2) {
            setSearchInvoice(e.target.value);
            setIsNewSearch(true);
        } else {
            setSearchInvoice();
        }
    };

    return (
        <input
            className="block w-full rounded-lg border border-gray-200 p-3 text-gray-600 hover:border-black"
            type="search"
            value={searchInvoice}
            onChange={handleChange}
            placeholder="Cauta codul unei facturi, numele organizatiei sau punctul de lucru..."
        />
    );
};


function ReturnOrders() {
    const [expandedInvoiceId, setExpandedInvoiceId] = useState<number | null>(null);
    const [workingPoints, setWorkingPoints] = useState<WorkingPointModel[]>([]);
    const [selectedWorkingPointId, setSelectedWorkingPointId] = useState<string | undefined>("");
    const [currentPage, setCurrentPage] = useState(0);
    const [searchInvoice, setSearchInvoice] = useState("");
    const [isNewSearch, setIsNewSearch] = useState(false);
    const [isLoadingSearch, setIsLoadingSearch] = useState(false);
    const [data, setData] = useState<InvoiceListResponse>();
    const [dateMin, setDateMin] = useState<any>();
    const [dateMax, setDateMax] = useState<any>(new Date());
    const [invoiceDetails, setInvoiceDetails] = useState<Record<string, InvoiceDetailsModel>>({});
    const [returnQuantities, setReturnQuantities] = useState<Record<number, Record<number, number | string>>>({});
    const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
    const [selectedInvoiceForReturn, setSelectedInvoiceForReturn] = useState<any>(null);
    const [totalReturn, setTotalReturn] = useState<number | null>(null);
    const [hashReturn, setHashReturn] = useState<string | null>(null);
    const [inputValue, setInputValue] = useState(currentPage + 1);
    const [debounceTimer, setDebounceTimer] = useState<NodeJS.Timeout | null>(null);
    const [invoiceSeriesId, setInvoiceSeriesId] = useState<number | null>(null);
    const pageSize = 30;

    const detailsRef = useRef<HTMLDetailsElement>(null);
    
    const handleWorkingPointChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setSelectedWorkingPointId(e.target.value);
        setSearchInvoice('');
        setIsNewSearch(true);
        setCurrentPage(0);
    };

    const toggleInvoice = (invoiceId: number) => {
        if (expandedInvoiceId === invoiceId) {
            setExpandedInvoiceId(null);
        } else {
            setExpandedInvoiceId(invoiceId);
            if (!invoiceDetails[invoiceId]) {
                fetchInvoiceDetails(invoiceId);
            }
        }
    };

    const handlePageChange = (selectedPage: any) => {
        setCurrentPage(selectedPage);
        setIsNewSearch(false);
    };

    useEffect(() => {
        setInputValue(currentPage + 1);
    }, [currentPage]);

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        let value = Number(e.target.value);

        if (data?.totalPages && value > data.totalPages) {
            value = data.totalPages;
        } else if (value < 1) {
            value = 1;
        }
        setInputValue(value);

        if (debounceTimer) clearTimeout(debounceTimer);

        const timer = setTimeout(() => {
            if (data?.totalPages && value >= 1 && value <= data?.totalPages) {
                handlePageChange(value - 1);
            }
        }, 500);

        setDebounceTimer(timer);
    };

    useEffect(() => {
        const fetchWorkingPoints = async () => {
            try {
                const response = await ApiHttpClient().post<WorkingPointResponse>(
                    `/workingPoint/search`,
                    {
                        pageNumber: 1,
                        pageSize: 100,
                        orderBy: ["workingPointName"],
                    }
                );
                setWorkingPoints(response.data.items || []);
            } catch (error) {
                console.error("Failed to fetch working points", error);
            }
        };

        fetchWorkingPoints();
    }, []);

    const handleRemoveFilters = () => {
        setSearchInvoice('');
        setIsNewSearch(false);
        setDateMin('');
        setDateMax(new Date());
    }

    const handlePreviewReturn = async (invoice: InvoiceListResponseItem) => {
        const invoiceArticles = invoiceDetails[invoice.id]?.invoiceDetails || [];
        const selectedArticles = invoiceArticles
            .filter((item) => (returnQuantities[invoice.id]?.[item.lineNumber] ?? 0) !== 0)
            .map((item) => {
                const rawQuantity = Number(returnQuantities[invoice.id][item.lineNumber]);
                return {
                    articleId: item.articleId,
                    quantity: Math.abs(rawQuantity),
                    salesPrice: item.salesPrice,
                    salesUnit: item.measureUnit,
                    vatPercent: item.vatPercent,
                    isPositive: rawQuantity > 0,
                    referencedInvoiceLine: item.lineNumber,
                    //displayName: item.article.longName,
                };
            })

        if (selectedArticles.length === 0) {
            toast({ description: "Nu ai selectat articole pentru retur" });
            return;
        }
        
       setSelectedInvoiceForReturn({ invoice, details: selectedArticles });
        
        try {
            const response = await ApiHttpClient().post(`/invoice/litigation?commit=false`, {
                litigationInvoice: {
                    referencedInvoiceId: invoiceSeriesId,
                    workingPointId: invoice.workingPointId,
                    currency: "RON",
                    invoiceSeries: invoice.invoiceSeries,
                    referencedInvoiceNumber: invoice.invoiceNumber,
                    // isPickup: true,
                    // timeSlot: "",
                    // articles: selectedArticles,
                    details: selectedArticles,
                    // totalWithoutVat: 0
                },
                hash: "",
            });
            
            if (response?.data?.hash) {
                setHashReturn(response.data.hash);
            }
            
            if (response?.data?.litigationInvoice.totalWithoutVat) setTotalReturn(response?.data?.litigationInvoice.totalWithoutVat)

            setIsConfirmModalOpen(true);
        } catch (error) {
            console.error("Eroare la pre-vizualizare retur:", error);
        }
    };


    const handleFinalizeReturn = async () => {
        try {
            await ApiHttpClient().post(`/invoice/litigation?commit=true`, {
                litigationInvoice: {
                    referencedInvoiceId: invoiceSeriesId,
                    workingPointId: selectedInvoiceForReturn?.invoice.workingPointId,
                    currency: "RON",
                    invoiceSeries:selectedInvoiceForReturn?.invoice.invoiceSeries,
                    referencedInvoiceNumber: selectedInvoiceForReturn?.invoice.invoiceNumber,
                    // isPickup: true,
                    //timeSlot: "",
                    details: selectedInvoiceForReturn?.details,
                },
                hash: hashReturn,
            });

            toast({ description: "Cererea de retur a fost transmisă" });

            setIsConfirmModalOpen(false);
        } catch (error) {
            toast({ description: "A apărut o eroare la generarea cererii de retur." });
            console.error("Eroare la finalizare retur:", error);
        }
    };
    
    useEffect(() => {
        const updateInvoices = async () => {
            setIsLoadingSearch(true);
            
            const filters = [];

            if (dateMin) {
                filters.push({
                    field: "invoiceDate",
                    operator: "gte",
                    value: new Date(dateMin).toISOString()
                });
            }

            if(dateMax) {
                filters.push({
                    field: "invoiceDate",
                    operator: "lte",
                    value: new Date(dateMax).toISOString()
                });
            }
            
            if (selectedWorkingPointId) {
                filters.push({
                    field: "workingPoint.Id",
                    operator: "eq",
                    value: selectedWorkingPointId,
                });
            }

            // filters.push({
            //     field: "invoiceSeries",
            //     operator: "eq",
            //     value: 'FRA',
            // });

            // const requestBodySearchAndDate = {
            //     advancedFilter: {
            //         logic: "and",
            //         filters: filters
            //     },
            //     advancedSearch: {
            //         fields: [
            //             "invoiceNumber",
            //             "workingPoint.Organization.Name",
            //             "workingPoint.Id" 
            //         ],
            //         keyword: searchInvoice
            //     },
            //     pageNumber: currentPage + 1,
            //     pageSize: pageSize,
            // }
            
            let requestBody: any = {
                advancedFilter: {
                    logic: "and",
                    filters,
                },
                pageNumber: currentPage + 1,
                pageSize: pageSize,
            };
            
            if (searchInvoice) {
                if (isNewSearch) setCurrentPage(0);

                requestBody = {
                    ...requestBody,
                    advancedSearch: {
                        fields: [
                            "invoiceNumber",
                            "workingPoint.Organization.Name",
                            "workingPoint.Id",
                        ],
                        keyword: searchInvoice,
                    },
                };
            }

            const response = await ApiHttpClient().post<InvoiceListResponse>(
                "/invoice/search",
                requestBody
            );
            if (!response?.data) {
                toast({description: "A aparut o eroare pentru afisarea precomenzilor"});
                return <></>;
            }
            setIsLoadingSearch(false);
            setData(response.data);
            setIsNewSearch(false);
        }

        updateInvoices();
    }, [searchInvoice, currentPage, pageSize, isNewSearch, dateMin, dateMax, selectedWorkingPointId])

    const fetchInvoiceDetails = async (invoiceId: number) => {
        setInvoiceSeriesId(invoiceId);
        
        try {
            const response = await ApiHttpClient().get<InvoiceDetailsModel>(`/invoice/${invoiceId}`);
            setInvoiceDetails(prev => ({
                ...prev,
                [invoiceId]: response.data
            }));
        } catch (error) {
            toast({ description: "Nu am putut încărca detaliile facturii" });
        }
    };


    return (
        <>
            <Navbar />
            <div className="flex flex-row items-start">
                <SideMenu />
                <div className="flex flex-col w-full">
                    {!isLoadingSearch && data?.totalPages === 0 &&
                        <p className="mt-5 ml-5 mb-3">Nu au fost gasite rezultate.</p>}
                    <div className="text-4xl px-8 py-3 mt-5">Initiere stornare factura</div>
                    <label className="flex justify-between items-center w-1/3 ml-12 my-6">
                        <span className="text-lg font-medium text-gray-700 mt-2 mr-16 text-nowrap">Working Point</span>
                        <select
                            value={selectedWorkingPointId}
                            onChange={handleWorkingPointChange}
                            className="bg-gray-100 rounded py-2 px-1.5 border-gray-300 border-2 shadow-sm sm:text-sm pl-2"
                        >
                            <option value="">Selectează un punct de lucru</option>
                            {workingPoints.map((wp) => (
                                <option key={wp.id} value={wp.id}>{wp.workingPointName} - {wp.id}</option>
                            ))}
                        </select>
                    </label>
                    <div className="overflow-x-auto px-2 py-1 w-full">
                        <div className="px-8 py-2 w-full">

                            <div className="flex justify-end mb-2 mr-2">
                                <button
                                    className="inline-flex items-center justify-center rounded-full bg-gray-100 px-2.5 py-0.5 text-gray-700"
                                    onClick={handleRemoveFilters}
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke-width="1.5"
                                        stroke="currentColor"
                                        className="size-3"
                                    >
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"/>
                                    </svg>

                                    <p className="text-sm whitespace-nowrap ml-2">Elimina filtrele</p>
                                </button>
                            </div>

                            <div className="mb-5">
                                <SearchInput searchInvoice={searchInvoice} setSearchInvoice={setSearchInvoice}
                                             setIsNewSearch={setIsNewSearch}/>
                            </div>

                            <details ref={detailsRef} className="group relative mb-5">
                                <summary
                                    className="mx-2 flex items-center gap-2 pb-1 text-gray-700 transition-colors [&::-webkit-details-marker]:hidden"
                                >
                                    <span className="text-sm font-medium"> Cauta facturile din </span>

                                    <span className="transition-transform group-open:-rotate-180">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        strokeWidth="1.5"
                                        stroke="currentColor"
                                        className="size-4"
                                    >
                                      <path strokeLinecap="round" strokeLinejoin="round"
                                            d="M19.5 8.25l-7.5 7.5-7.5-7.5"/>
                                    </svg>
                                  </span>
                                </summary>

                                <div
                                    className="z-100 w-64 divide-y divide-gray-300 rounded border border-gray-300 bg-white shadow-sm group-open:absolute group-open:start-0 group-open:top-8"
                                >
                                    <div className="flex items-center justify-between px-3 py-2">
                                        <span className="text-sm text-gray-700"> Selecteaza datele </span>

                                        <button
                                            type="button"
                                            onClick={() => {
                                                setDateMin('');
                                                setDateMax(new Date())
                                            }}
                                            className="text-sm text-gray-700 underline transition-colors hover:text-gray-900"
                                        >
                                            Reset
                                        </button>
                                    </div>

                                    <div className="flex items-center gap-3 p-3">
                                        <label htmlFor="MinPrice">
                                            <span className="text-sm text-gray-700"> Data de inceput </span>

                                            <DatePicker
                                                selected={dateMin}
                                                onChange={(dateMin) => setDateMin(dateMin)}
                                                dateFormat="dd/MM/yyyy"
                                                className="mt-0.5 w-full rounded border-gray-300 shadow-sm sm:text-sm z-100"
                                                popperPlacement="bottom-start"
                                                popperModifiers={[
                                                    {
                                                        name: "preventOverflow",
                                                        options: {boundary: "viewport", tether: false},
                                                        fn: () => ({}),
                                                    },
                                                    {
                                                        name: "flip",
                                                        options: {fallbackPlacements: []}, // Prevents flipping above
                                                        fn: () => ({}),
                                                    },
                                                ]}
                                                portalId="root-portal" // Ensures calendar is rendered outside restrictive containers
                                            />
                                        </label>

                                        <label htmlFor="MaxPrice">
                                            <span className="text-sm text-gray-700"> Data de sfarsit </span>

                                            <DatePicker
                                                selected={dateMax}
                                                onChange={(dateMax) => setDateMax(dateMax)}
                                                dateFormat="dd/MM/yyyy"
                                                className="mt-0.5 w-full rounded border-gray-300 shadow-sm sm:text-sm z-100"
                                                popperPlacement="bottom-start"
                                                popperModifiers={[
                                                    {
                                                        name: "preventOverflow",
                                                        options: {boundary: "viewport", tether: false},
                                                        fn: () => ({}),
                                                    },
                                                    {
                                                        name: "flip",
                                                        options: {fallbackPlacements: []},
                                                        fn: () => ({}),
                                                    },
                                                ]}
                                                portalId="root-portal"
                                            />
                                        </label>
                                    </div>
                                </div>
                            </details>

                            <table className="w-full divide-y divide-gray-200 border">
                                <thead
                                    className="text-xs text-left text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                                <tr>
                                    <th scope="col" className="px-6 py-3">
                                        Id Factura
                                    </th>
                                    <th scope="col" className="px-6 py-3">
                                        Status
                                    </th>
                                    <th scope="col" className="px-6 py-3">
                                        Punct de lucru
                                    </th>
                                    <th scope="col" className="px-6 py-3">
                                        Numele organizatiei
                                    </th>
                                    <th scope="col" className="px-6 py-3">
                                        Data
                                    </th>
                                </tr>
                                </thead>
                                <tbody className="bg-white divide-y divide-gray-200">
                                {!isLoadingSearch && data?.totalPages === 0 &&
                                    <p className="mt-5 ml-5 mb-3">Nu au fost gasite rezultate.</p>}
                                {data?.items.map((invoice: InvoiceListResponseItem) => (
                                    <React.Fragment key={invoice.id}>
                                        <tr
                                            className="cursor-pointer hover:bg-gray-50 transition"
                                            onClick={() => toggleInvoice(invoice.id)}
                                        >
                                            <td className="px-6 py-4">
                                                {invoice.invoiceSeries} {invoice.invoiceNumber}
                                            </td>
                                            <td className="px-6 py-4">
                                                {invoice.status}
                                            </td>
                                            <td className="px-6 py-4">
                                                {invoice.workingPointId}
                                            </td>
                                            <td className="px-6 py-4">
                                                {invoice.organizationName}
                                            </td>
                                            <td className="px-6 py-4 text-sm text-gray-700">
                                                {invoice.date?.split("T")[0]}
                                            </td>
                                        </tr>
                                        {expandedInvoiceId === invoice.id && (
                                            <tr>
                                                <td colSpan={6} className="px-6 py-4 bg-gray-100 w-full">
                                                    <div className="flex justify-between items-center w-full">    
                                                        <div className="text-gray-800 font-semibold mb-2">Articole:</div>
                                                   
                                                        <div className="mt-4 mx-2 text-center text-nowrap">
                                                            <button
                                                                type="button"
                                                                onClick={() => handlePreviewReturn(invoice)}
                                                                className="inline-block w-full rounded-lg bg-red-500 px-3 py-1 mb-3 text-nowrap text-sm font-medium text-white sm:w-auto"
                                                            >
                                                                Previzualizare retur <span
                                                                className="block"> {invoice.invoiceSeries} {invoice.invoiceNumber}</span>
                                                            </button>
                                                        </div>
                                                    </div>

                                                    {isConfirmModalOpen && selectedInvoiceForReturn && (
                                                        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
                                                            <div className="bg-white rounded-xl p-6 w-1/2 max-h-[80vh] overflow-y-auto shadow-lg">
                                                                <h2 className="text-2xl font-bold mb-4">Confirmare retur</h2>
                                                                <p className="mb-4 text-lg">
                                                                    Esti sigur ca vrei sa trimiti urmatoarele articole pentru retur?
                                                                </p>

                                                                <table className="w-full text-sm border mb-4">
                                                                    <thead className="bg-gray-200">
                                                                    <tr>
                                                                        <th className="px-4 py-2 text-left">Cod produs</th>
                                                                        <th className="px-4 py-2 text-left">Nume produs</th>
                                                                        <th className="px-4 py-2 text-center">Cantitate</th>
                                                                        <th className="px-4 py-2 text-center">UM</th>
                                                                        <th className="px-4 py-2 text-center">Pret unitar</th>
                                                                    </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                    {selectedInvoiceForReturn.details?.map((art: any, index: number) => (
                                                                        <tr key={index} className="border-t">
                                                                            <td className="px-4 py-2">{art.articleId}</td>
                                                                            <td className="px-4 py-2">{art.displayName}</td>
                                                                            <td className="px-4 py-2 text-center">{!art.isPositive ? "-" : "" }{art.quantity}</td>
                                                                            <td className="px-4 py-2 text-center">{art.salesUnit}</td>
                                                                            <td className="px-4 py-2 text-center">{art.salesPrice.toFixed(2)}</td>
                                                                        </tr>
                                                                    ))}
                                                                    </tbody>
                                                                </table>

                                                                {totalReturn && <div className="text-xl my-2">Total cerere retur: {totalReturn} RON</div>}

                                                                <div className="flex justify-end gap-3">
                                                                    <button
                                                                        onClick={() => setIsConfirmModalOpen(false)}
                                                                        className="px-4 py-2 rounded bg-gray-200 hover:bg-gray-300"
                                                                    >
                                                                        Anulează
                                                                    </button>
                                                                    <button
                                                                        onClick={handleFinalizeReturn}
                                                                        className="px-4 py-2 rounded bg-red-500 text-white hover:bg-red-600"
                                                                    >
                                                                        Trimite retur
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}

                                                    {!isConfirmModalOpen && <table className="w-full text-sm border">
                                                    <thead className="bg-gray-200">
                                                        <tr>
                                                            <th className="px-4 py-2 text-left">Cod produs</th>
                                                            <th className="px-4 py-2 text-left">Denumire produs</th>
                                                            <th className="px-4 py-2 text-center">UM</th>
                                                            <th className="px-4 py-2 text-center">Cantitate facturata
                                                            </th>
                                                            <th className="px-4 py-2 text-center">Cantitate returnata
                                                            </th>
                                                            <th className="px-4 py-2 text-center">Pret unitar (fara TVA)
                                                            </th>
                                                            <th className="px-4 py-2 text-center">Cota TVA
                                                            </th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        {invoiceDetails[invoice.id]?.invoiceDetails?.map((item) => (
                                                            <tr key={item.lineNumber}>
                                                                <td className="px-4 py-2">{item.articleId}</td>
                                                                <td className="px-4 py-2">{item.article.longName}</td>
                                                                <td className="px-4 py-2 text-center">{item.measureUnit === 'A' &&
                                                                    <p>Bucata</p>} {item.measureUnit === 'K' &&
                                                                    <p>Kilogram</p>} {item.measureUnit === 'M' &&
                                                                    <p>Metru</p>}</td>
                                                                <td className="px-4 py-2 text-center">
                                                                    {item.quantity}
                                                                </td>
                                                                {!item.hasLitigation && <td className="px-4 py-2 text-center">
                                                                    <input
                                                                        type="number"
                                                                        className="px-2 py-1 w-24"
                                                                        value={returnQuantities[invoice.id]?.[item.lineNumber] ?? ""}
                                                                        onChange={(e) => {
                                                                            let value = e.target.value;

                                                                            if (value === "-") {
                                                                                setReturnQuantities((prev) => ({
                                                                                    ...prev,
                                                                                    [invoice.id]: {
                                                                                        ...prev[invoice.id],
                                                                                        [item.lineNumber]: value,
                                                                                    },
                                                                                }));
                                                                                return;
                                                                            }

                                                                            let parsed = parseFloat(value);

                                                                            if (isNaN(parsed)) {
                                                                                parsed = 0;
                                                                            }

                                                                            if (parsed < -item.quantity) parsed = -item.quantity;
                                                                            if (parsed > item.quantity) parsed = item.quantity;

                                                                            setReturnQuantities((prev) => ({
                                                                                ...prev,
                                                                                [invoice.id]: {
                                                                                    ...prev[invoice.id],
                                                                                    [item.lineNumber]: parsed,
                                                                                },
                                                                            }));

                                                                        }}
                                                                        onBlur={(e) => {
                                                                            if (e.target.value === "-") {
                                                                                setReturnQuantities((prev) => ({
                                                                                    ...prev,
                                                                                    [invoice.id]: {
                                                                                        ...prev[invoice.id],
                                                                                        [item.lineNumber]: 0,
                                                                                    },
                                                                                }));
                                                                            }
                                                                        }}
                                                                        id="returCount"
                                                                        placeholder="0"
                                                                        onKeyDown={(e) => {
                                                                            if (e.key === "." || e.key === ",") {
                                                                                e.preventDefault();
                                                                            }
                                                                        }}
                                                                        min={0}
                                                                        max={item.quantity}
                                                                    />
                                                                </td>}
                                                                {item.hasLitigation && <p className="text-center text-red-700">Retur inregistrat</p>}
                                                                <td className="px-4 py-2 text-center">{item.salesPrice.toFixed(2)} RON</td>
                                                                <td className="px-4 py-2 text-center">{item.arvatCode.vatPercent} %</td>
                                                            </tr>
                                                        ))}
                                                        </tbody>
                                                    </table>}
                                                </td>
                                            </tr>
                                        )}
                                    </React.Fragment>
                                ))}
                                </tbody>
                            </table>
                        </div>

                        <div className="text-center mt-8 mb-2">
                            <ul className="flex justify-center gap-1 text-gray-900 mt-3">
                                <li>
                                    <button
                                        onClick={(e) => {
                                            e.preventDefault();
                                            if (currentPage > 0) handlePageChange(currentPage - 1);
                                        }}
                                        className="grid mr-2 size-8 place-content-center rounded border border-gray-200 transition-colors hover:bg-gray-50 rtl:rotate-180"
                                        aria-label="Previous page"
                                        disabled={currentPage === 0}
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            className="size-4"
                                            viewBox="0 0 20 20"
                                            fill="currentColor"
                                        >
                                            <path
                                                fillRule="evenodd"
                                                d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                                                clipRule="evenodd"
                                            />
                                        </svg>
                                    </button>
                                </li>

                                <li>
                                    <label htmlFor="Page" className="flex items-center gap-1">
                                        <span className="sr-only">Pagina</span>
                                        <input
                                            type="number"
                                            id="Page"
                                            value={inputValue}
                                            min={1}
                                            max={data?.totalPages}
                                            onChange={handleInputChange}
                                            className="h-8 w-10 rounded border-gray-300 text-center sm:text-sm"
                                        />
                                        <span className="text-sm">/ {data?.totalPages}</span>
                                    </label>
                                </li>

                                <li>
                                    <button
                                        onClick={(e) => {
                                            e.preventDefault();
                                            if (data && currentPage < data.totalPages - 1) handlePageChange(currentPage + 1);
                                        }}
                                        className="grid ml-2 size-8 place-content-center rounded border border-gray-200 transition-colors hover:bg-gray-50 rtl:rotate-180"
                                        aria-label="Next page"
                                        disabled={data && currentPage === data.totalPages - 1}
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            className="size-4"
                                            viewBox="0 0 20 20"
                                            fill="currentColor"
                                        >
                                            <path
                                                fillRule="evenodd"
                                                d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                                                clipRule="evenodd"
                                            />
                                        </svg>
                                    </button>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </>);
}

export default ReturnOrders;

